import { LocalStorageKeys } from "@is/constants";
import { useStoreLanguage } from "@is/hooks";
import { LocalStorageService } from "@is/services";
import { convertAlpha3ToAlpha2, getLanguageFromLocalStorage } from "@is/utils";

const useManageLanguageAndCountryButton = () => {
  const { storeLanguageCode } = useStoreLanguage();

  const selectedLanguageCode =
    getLanguageFromLocalStorage() ?? storeLanguageCode;

  const selectedCountryCode = LocalStorageService.getItem(
    LocalStorageKeys.CountryCode
  )
    ? convertAlpha3ToAlpha2(
        LocalStorageService.getItem(LocalStorageKeys.CountryCode)
      )
    : "";

  return {
    selectedLanguageCode,
    selectedCountryCode,
  };
};

export default useManageLanguageAndCountryButton;
